import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { AuthService } from '@tv3/services/auth.service'
import * as lodash from 'lodash'
import { ConfirmDialogService, UploadBoxComponent, UploadBoxOptions } from '@tokeet-frontend/tv3-platform'
import { TemplateUploadResponse } from '@tokeet-frontend/signature'
import { environment } from '@tv3/environments/environment'

@Component({
  selector: 'app-template-uploader',
  templateUrl: './template-uploader.component.html',
  styleUrls: ['./template-uploader.component.scss'],
})
export class TemplateUploaderComponent implements OnInit {
  @ViewChild('uploadBox') uploader: UploadBoxComponent

  @Input() isOnetime = false
  @Input() uploadedFilesData: TemplateUploadResponse[] = []
  @Output() uploaded = new EventEmitter<TemplateUploadResponse[]>()

  get fileItemsCount() {
    return this.uploadedFilesData?.length
  }

  constructor(private authService: AuthService, private confirm: ConfirmDialogService) {}

  ngOnInit() {}

  getUploadBoxOptions(): UploadBoxOptions {
    return {
      uploadUrl: `${environment.signatureApiUrl}/${this.authService.accountId}/files/convert`,
      maxSize: 10 * 1024 * 1024, // 10MB,
      maxUploads: 10,
      autoUpload: true,
      allowedFileExtensions: ['.png', '.jpg', '.jpeg', '.pdf', '.doc', '.docx', 'xlsx'],
      token: this.authService.token,
      guide:
        $localize`You can only upload files that are ` +
        `<b>` +
        $localize`10 MB` +
        `</b>` +
        $localize` or smaller. Only ` +
        `<b>PDF, JPG, PNG, RTF, TXT, DOCX</b>` +
        $localize` and ` +
        `<b>DOC</b>` +
        $localize` file types are allowed. ` +
        `<br/>` +
        $localize`If multiple files are selected, they will be merged together into a single document.`,
    }
  }

  onFilesUploaded(data: TemplateUploadResponse[]) {
    const items = lodash.uniqBy([...this.uploadedFilesData, ...data], (item) => item.pdf_file_url)
    this.uploadedFilesData = items
    this.uploaded.emit(items)
  }

  onFileOrderChanged() {
    this.uploaded.emit(this.uploadedFilesData)
  }

  getUploadingFileItem() {
    return lodash.filter(this.uploader?.files, (item) => {
      return !item.isSuccess
    })
  }

  onRemoveItem(index: number) {
    this.confirm
      .confirm({
        title: 'Remove this file?',
        body: 'Are you sure you want to remove this file?',
      })
      .subscribe(() => {
        this.uploadedFilesData.splice(index, 1)
        this.uploaded.emit(this.uploadedFilesData)
      })
  }
}
